/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, intCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { getApiTargetInfo } from 'core'
import {
  modifierCol,
  modifiedDateCol,
  YNBooleanTypes,
} from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getCauseCodeMgmtInfo,
  postCauseCodeMgmtInfo,
  deleteCauseCodeMgmtInfo,
} from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { Input, Button, Switch, InputNumber } from 'antd'
import { CAUSE_CODE, STORE_CAUSE_CODE_MAP } from 'core/action-names'
import R from 'ramda'
const headers = [
  intCol({
    ident: 'causeCode',
    display: 'Cause Code',
    isKey: true,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 1400,
    alignment: 'left',
    isRequired: true,
  }),
  strCol({
    ident: 'omc',
    display: 'Outside Management Control',
    ...toSelectionColProps(YNBooleanTypes),
    width: 170,
    isRequired: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getCauseCodeMgmtInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postCauseCodeMgmtInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteCauseCodeMgmtInfo(apiTargetInfo)(data)

const title = 'Cause Code Management'
const { TextArea } = Input
const CauseCodeMgmt = props => {
  // const [] = useState({
  //   causeCode: undefined,
  //   description: undefined,
  //   omc: 'N',
  // })
  const [insertEvent, setInsertEvent] = useState(false)

  const causeCodeList = R.compose(
    R.fromPairs,
    R.map(a => [a.causeCode, a.description])
  )

  const onRetrieveData = data => {
    props.saveCauseCodeMap(causeCodeList(data))
  }

  // const onAdd = ({ hide, retrieve }) => {
  //   const validate = validateData()
  //   if (validate)
  //     modifyTask(props.apiTargetInfo)([insertData]).fork(setErr, _ => {
  //       message.info('Data Saved')
  //       setInsertEvent(!hide)
  //       setInsertData({ causeCode: undefined, description: undefined, omc: 'N' })

  //       retrieve && retrieve()
  //       reloadCauseCode()
  //     })
  // }
  // const onCancel = () => {
  //   setInsertEvent(false)
  // }
  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ width: '80px' }}>Cause Code:</td>
            <td style={{ width: '200px' }}>
              <InputNumber
                placeholder="Cause Code"
                value={insertData.causeCode}
                onChange={value =>
                  setInsertData({
                    ...insertData,
                    causeCode: value,
                  })
                }
                style={{ width: '200px' }}
              />
            </td>
            <td style={{ width: '200px' }}>Outside Management Control :</td>
            <td>
              <Switch
                id="OMC"
                checkedChildren="True"
                unCheckedChildren="False"
                value={insertData.omc !== 'N'}
                onChange={value =>
                  setInsertData({ ...insertData, omc: value ? 'Y' : 'N' })
                }
              />
            </td>
            <td>
              <Button
                type="primary"
                onClick={() => onAdd(true)}
                style={{ marginRight: '20px' }}
              >
                Add
              </Button>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
              <Button
                type="danger"
                onClick={onCancel}
                style={{ marginLeft: '10px', marginRight: '20px' }}
              >
                Cancel
              </Button>
            </td>
          </tr>
          <tr>
            <td style={{ width: '80px' }}>Description :</td>
            <td colSpan={4}>
              <TextArea
                placeholder="Description"
                value={insertData.description}
                onChange={value =>
                  setInsertData({
                    ...insertData,
                    description: value.target.value,
                  })
                }
                autoSize={{ minRows: 1, maxRows: 2 }}
              />
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.causeCode}
      autoRetrieve
      sortOptions={[
        { ident: 'causeCode', display: 'Cause Code', sortOrder: 'dec' },
      ]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={80}
      onInsertEvent={b => setInsertEvent(b)}
      // afterSaveTask={reloadCauseCode}
      onRetrieveData={onRetrieveData}
      defaultInsertData={{ omc: 'N' }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

const mapDispatchToMap = dispatch => ({
  saveCauseCode: causeCode =>
    dispatch({ type: CAUSE_CODE, payload: causeCode }),
  saveCauseCodeMap: map =>
    dispatch({ type: STORE_CAUSE_CODE_MAP, payload: map }),
})

export default connect(mapStateToProps, mapDispatchToMap)(CauseCodeMgmt)
